import { useEffect, useState } from "react";
import QRCode from "qrcode";

export default function QrCodeImage({
    phoneNumber,
    height,
    width,
}: {
    phoneNumber?: string;
    height?: string;
    width?: string;
}) {
    const [qrCodeImg, setQrCodeImg] = useState<string | undefined>(undefined);
    useEffect(() => {
        if (!phoneNumber) return;

        const fetchQr = async () => {
            try {
                const value = `tel:${phoneNumber}`;
                const url = await QRCode.toDataURL(value);
                setQrCodeImg(url);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("error in getting QR code:", err);
            }
        };

        void fetchQr();
    }, [phoneNumber]);

    if (phoneNumber == undefined || phoneNumber == "") {
        return <></>;
    }

    return (
        <div className="qrContainer">
            {qrCodeImg && (
                <img
                    src={qrCodeImg}
                    alt="QR Code"
                    height={`${height ?? 100}px`}
                    width={`${width ?? 100}px`}
                />
            )}
        </div>
    );
}
